
import { useSession } from "../context/SessionApi";
export const SEASONS = {
  SPRING: "February series",
  SUMMER: "June series",
  WINTER: "Winter",
};

export const AssessmentCriteria = {
  ACHIEVED: "Achieved",
  NOT_ACHIEVED: "Not Achieved",
  NOT_ATTEMPTED: "Not Attempted"
}

export const AssessmentCriteriaInputValues = {
  YES: "yes",
  NO: "no",
  NOT_ATTEMPTED: "not_attempted"
}


export const mapModerationWindowSession = (sessions) => {
  const result = { window1: null, window2: null };
  sessions.forEach((s) => {
    if (s.window === 1) result.window1 = s.sessionId;
    if (s.window === 2) result.window2 = s.sessionId;
  });

  return result;
};

export const useModerationWindowSession = () => {
  const sessions = useSession(); // array from SessionProvider
  const apiData = sessions || [];

  return {
    ...mapModerationWindowSession([]),   // fallback values
    ...mapModerationWindowSession(apiData), // override with API values
  };
};

// dynamic year label function
export const getYearLabel = () => {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 1;
  const endYearShort = String(currentYear).slice(-2);

  return `${startYear}/${endYearShort}`;
};



export function formatDate(isoDate) {
  const dt = new Date(isoDate);
  const day = String(dt.getDate()).padStart(2, '0');
  const month = dt.toLocaleString("en-GB", { month: "long" });
  const year = dt.getFullYear();
  return `${day} ${month} ${year}`;
}

const currentYear = new Date().getFullYear();
const yearLabel = `${currentYear}/${String(currentYear + 1).slice(-2)}`;


export const MARK_STATUS = {
  SAVED: 24,
  SUBMITTED: 25,
  RESUBMITTED: 26,
  RE_RESUBMITTED: 61
}

export const QUALIFICATION_NAME = {
  AAQS_SUBJECT_NAME: 'AAQ CAN Reg',
  ENRICHMENT_SUBJECT_NAMES: [
    'L3 Cert Reg',
    'Level 3 Award'
  ]
}

export const QUALIFICATION_TITLES = {
  "AAQ CAN Reg": "Cambridge Advanced Nationals (AAQs)",
  "L3 Cert Reg": "Enrichment qualifications",
  "Level 3 Award": "Enrichment qualifications"
}

export const UI_MESSAGES = {
  NO_DATA_FOUND: 'No Data Found'
};

export const MODERATION_TYPE = {
  FACE_TO_FACE: 'Face-to-Face',
  VIRTUAL: 'Virtual'
};

export const MODERATION_TYPE_LABELS = {
  [MODERATION_TYPE.FACE_TO_FACE]: "Face-to-face",
  [MODERATION_TYPE.VIRTUAL]: "Virtual"
};

export const VISIT_STATUS = {
  REQUESTED: "Visit Requested"
};

export const CERTIFICATE_CODES = {
  LEVEL_3_SUSTAINABILITY: "HO82"
};

export const windowLabelsByIndex = {
  0: ["Window 1 (February series)", "Window 2 (June series)"],
  1: ["Window 1 (February series)", "Window 2 (June series)"]
};

export const AUTO_SAVE_DELAY_MS = 300000; // 5 minutes in milliseconds

